const fragment = `
  id
  imageUrl
`;

export const listFloorOptionImagesQuery = `
  query ListFloorOptionImages(
    $filter: FloorOptionImageFilterInput
  ) {
    items: listFloorOptionImages(filter: $filter) {
      ${fragment}
    }
  }
`;

export const createFloorOptionImageQuery = `
  mutation CreateFloorOptionImage(
    $input: CreateFloorOptionImageInput!
    $image: Upload
  ) {
    item: createFloorOptionImage(input: $input, image: $image) {
      ${fragment}
    }
  }
`;

export const updateFloorOptionImageQuery = `
  mutation UpdateFloorOptionImage(
    $input: UpdateFloorOptionImageInput!
    $image: Upload
  ) {
    item: updateFloorOptionImage(input: $input, image: $image) {
      ${fragment}
    }
  }
`;

export const deleteFloorOptionImageQuery = `
  mutation DeleteFloorOptionImage(
    $id: Int!
  ) {
    item: deleteFloorOptionImage(id: $id) {
      ${fragment}
    }
  }
`;
